<script setup lang="ts">
    import { computed } from 'vue'
    import { ErrorData, getViolationsFeedback } from '@/js/utils'

    const emit = defineEmits(['update:modelValue'])

    export interface Props {
        modelValue: File | File[] | null | undefined
        accept?: string
        label?: string
        hint?: string
        placeholder?: string
        dataTest?: string
        error?: ErrorData
        violationFields?: string[]
        isLoading?: boolean
        disabled?: boolean
    }

    const props = withDefaults(defineProps<Props>(), {
        accept: '',
        label: '',
        hint: '',
        placeholder: '',
        violationFields: () => [] as string[],
        dataTest: '',
        error: () => {
            return {} as ErrorData
        },
        isLoading: false,
        disabled: false
    })

    const value = computed({
        get: () => props.modelValue,
        set: (val) => emit('update:modelValue', val)
    })

    const errorMessages = computed(() => {
        return props.error ? getViolationsFeedback(props.violationFields, props.error) : ''
    })
</script>

<template>
    <v-file-input
        v-model="value"
        :disabled="isLoading || disabled"
        counter
        :accept="accept"
        :label="label"
        :placeholder="placeholder"
        :data-test="dataTest"
        variant="outlined"
        base-color="primary"
        color="primary"
        density="compact"
        show-size
        class="mb-2"
        :hint="hint"
        :persistent-hint="!!hint"
        :hide-details="!hint && !errorMessages?.length"
        :error-messages="errorMessages"
        :error="!!errorMessages?.length"
    />
</template>

<style scoped></style>
